import { useLazyQuery } from '@apollo/client';
import carSpecifications from '../../graphql/queries/carSpecifications';
import {
  GetCarSpecifications,
  GetCarSpecificationsVariables,
} from '../../graphql/queries/__generated__/GetCarSpecifications';
import useCustomizeCarContext from '../useCustomizeCarContext';

const useCarSpecifications = () => {
  const { selectedCar } = useCustomizeCarContext();
  const carId = selectedCar?.car.byoCode;

  const [loadCarSpecifications, { data, loading, error }] = useLazyQuery<
    GetCarSpecifications,
    GetCarSpecificationsVariables
  >(carSpecifications.GET_CAR_SPECIFICATIONS, {
    variables: {
      carId,
    },
  });

  return { data, loading, error, loadCarSpecifications };
};

export default useCarSpecifications;
